import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { DialogTitleWithClose, TabsPanel } from 'ui';

import { ShopProduct } from './ShopProduct/ShopProduct';

const useStyles = makeStyles(() => ({
  product: {
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: 640,
  },
}));

const ShopProductsModal = ({ open, onClose, products, activeProduct }) => {
  const classes = useStyles();

  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth="lg">
        <DialogTitleWithClose onClose={onClose} />
        <DialogContent>
          <TabsPanel active={String(activeProduct)}>
            {products.map(product => (
              <Box
                mt={4}
                className={classes.product}
                label={product.name}
                value={String(product.id)}
                key={product.id}
              >
                <ShopProduct data={product} collapsed />
              </Box>
            ))}
          </TabsPanel>
        </DialogContent>
      </Dialog>
    </div>
  );
};

ShopProductsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  activeProduct: PropTypes.number.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export { ShopProductsModal };
